require('./chatMembersDropdown.i18n.json');
require('./chatMembersDropdown.tpl.html');
require('./chatMembersDropdownController.js');

const ChatMembersDropdownComponent = {
    templateUrl: '/collaboration/chat/chatMembers/chatMembersDropdown/chatMembersDropdown.tpl.html',
    controller: 'chatMembersDropdownController',
    bindings: {
        chatMembers: '<',
        hasInvitePermission:'<'
    }
};

angular.module('gw-um-submission')
    .component('uiChatMembersDropdown', ChatMembersDropdownComponent);
